module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0015.jpg?v=32674131";